import { useCommunityFeedActionMutation } from './useCommunityFeedActionMutation';

export const DELETE_POST_ACTION = '/delete_community_post';

interface DeletePostVars {
  postId: string;
  isModeratorRemoval: boolean;
  reason?: string;
}

/**
 * Deletes/removes a community post. On settle the feed/comment caches are invalidated and
 * refetched, so the removed post drops out on the next fetch (the fix for WEB-8821 — it no
 * longer reappears, no manual refresh needed). Moderator removals carry `mod_flag` + an
 * optional reason.
 */
export const useDeletePostMutation = () =>
  useCommunityFeedActionMutation<DeletePostVars>({
    buildRequest: ({ postId, isModeratorRemoval, reason }) => ({
      path: DELETE_POST_ACTION,
      fields: {
        post_id: postId,
        mod_flag: isModeratorRemoval ? 'true' : 'false',
        ...(reason ? { reason } : {}),
      },
    }),
  });
